type PropertyMapItem = {
  localizationKey: string
  objectKey: string
}

export const propertyMaps = {
  initiative: [
    { objectKey: 'status', localizationKey: 'initiativeStatus' },
    { objectKey: 'users.$role', localizationKey: 'userInitiativeRole' },
  ],
}

export const pluralize = (
  translation: { singular: string; plural: string },
  number: number,
) => {
  return enrich(
    number === 1 ? translation.singular : translation.plural,
    number,
  )
}

export const enrich = (translation: string, ...params: (string | number)[]) => {
  const placeholderRegex = /\{\d+\}/
  if (!placeholderRegex.test(translation) && params.length === 1)
    {return `${params[0]} ${translation}`}

  let processedString = translation
  params.forEach((param, index) => {
    const placeholder = `{${index}}`

    if (!translation.includes(placeholder))
      {console.error('i18n: Param mismatch')}

    const paramString = param !== undefined && param !== null ? param.toString() : ''
    processedString = processedString.replace(placeholder, paramString)
  })

  if (placeholderRegex.test(processedString))
    {console.error('i18n: Param mismatch')}

  return processedString
}

export const localize = (
  localizationSource: any,
  entity: any,
  propertyMap: PropertyMapItem[],
): any[] => {
  const localization = Array.isArray(localizationSource)
    ? localizationSource[0]
    : localizationSource

  const collection = Array.isArray(entity) ? entity : [entity]

  return collection.map((object) => {
    propertyMap.forEach((p) => {
      if (p.objectKey.includes('.')) {
        const parts = p.objectKey.split('.')
        const target = object[parts[0]]
        if (target === undefined)
          {throw new Error(
            `Complex property ${
              p.objectKey
            } missing list in object ${JSON.stringify(object)} at property ${
              parts[0]
            }`,
          )}

        const nestedPropertyMap = [
          {
            localizationKey: p.localizationKey,
            objectKey: parts.slice(1).join('.'),
          },
        ]
        localize(localization, target, nestedPropertyMap)
        return
      }

      const preLocalized = object[p.objectKey]
      if (object[p.objectKey] === undefined)
        {throw new Error(
          `Property ${p.objectKey} is missing on the object ${JSON.stringify(
            object,
          )}`,
        )}
      if (localization[p.localizationKey] === undefined)
        {throw new Error(
          `Property ${
            p.localizationKey
          } is missing on the object ${JSON.stringify(localization)}`,
        )}
      object[p.objectKey] = localization[p.localizationKey][preLocalized]
    })
    return object
  })
}
